import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
const MainContentLabelContext = /*#__PURE__*/createContext();
const MainContentLabelProvider = _ref => {
  let {
    children,
    id
  } = _ref;
  return /*#__PURE__*/React.createElement(MainContentLabelContext.Provider, {
    value: {
      id
    }
  }, children);
};
process.env.NODE_ENV !== "production" ? MainContentLabelProvider.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node
} : void 0;
const useMainContentLabel = () => useContext(MainContentLabelContext);
export { MainContentLabelProvider, useMainContentLabel };